import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="dOYGMS6R838"
                    title="IN-7011 HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-7011 HD Objektivjustage"
              footer={
                <EuiText>
                  <p>In diesem Video erklären wir Ihnen wie Sie bei Ihrer Überwachungskamera IN-7011HD manuell das Objektiv scharfstellen können sofern Sie einen Bereich überwachen möchten der sich sehr nahe bzw. sehr weit weg von der Kamera befindet.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}


// import React from 'react'

// import { Player } from 'video-react'

// import {
//     EuiText,
//     EuiTitle,
//     EuiIcon,
//     EuiPanel
//   } from '@elastic/eui'

// import { OutboundLink } from 'gatsby-plugin-gtag'

// require('../../../Layout/chrome/assets/video.css')

// function VideoCard() {
//   return (
//     <EuiPanel paddingSize="m">
//         <EuiTitle size="s"><h4>Lense Adjustment</h4></EuiTitle>
//         <Player>
//         <source src="https://wiki.instar.com/videos/Objektiv_scharfstellen_bei_einer_INSTAR_IN7011HD.mp4" />
//         </Player>
//         <EuiText>
//             <p>In diesem Video erklären wir Ihnen wie Sie bei Ihrer Überwachungskamera IN-7011HD manuell das Objektiv scharfstellen können sofern Sie einen Bereich überwachen möchten der sich sehr nahe bzw. sehr weit weg von der Kamera befindet. Auf <OutboundLink href="https://www.youtube.com/watch?v=dOYGMS6R838" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
//         </EuiText>
//     </EuiPanel>
//   );
// }

// export default VideoCard